import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';
const _excluded = ["color", "disableShrink", "size", "thickness", "variant", "value"];
function Spinner(_ref) {
  let {
      color,
      disableShrink,
      size,
      thickness,
      variant,
      value
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(CircularProgress, _extends({
    color: color,
    disableShrink: disableShrink,
    size: size,
    thickness: thickness,
    variant: variant,
    value: value
  }, otherProps));
}
Spinner.propTypes = {
  /**
   * The color of the component. It supports both default and custom theme colors, which can be added as shown in the palette customization guide.
   */
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'success', 'error', 'info', 'warning']),
  /**
   * If true, the shrink animation is disabled. This only works if variant is indeterminate.
   */
  disableShrink: PropTypes.bool,
  /**
   * The size of the component. If using a number, the pixel unit is assumed. If using a string, you need to provide the CSS unit, e.g '3rem'.
   */
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * 	The thickness of the circle.
   */
  thickness: PropTypes.number,
  /**
   * 	The value of the progress indicator for the determinate variant. Value between 0 and 100.
   */
  value: PropTypes.number,
  /**
   * 	The variant to use. Use indeterminate when there is no progress value.
   */

  variant: PropTypes.oneOf(['determinate', 'indeterminate'])
};
Spinner.defaultProps = {
  color: 'primary',
  disableShrink: false,
  size: '3rem',
  thickness: 3.6,
  value: 0,
  variant: 'indeterminate'
};
export { Spinner as default };